<template>
    <div>
      <div class="modal hide fade" id="modalPurchasingRequestEdit" tabindex="-1" role="dialog" aria-labelledby="modalPurchasingRequestEdit" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Request Edit</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-group">
                        <label for="request_edit" class="col-form-label">Request: </label>
                        (max: <span v-text="(max - request_edit.length)" style="color: blue;"></span>)
                        <textarea v-model="request_edit" class="form-control" rows="5" :maxlength="max"></textarea>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="requestEdit">Process</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal hide fade" id="modalPurchasingRequestVoid" tabindex="-1" role="dialog" aria-labelledby="modalPurchasingRequestVoid" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Request Delete</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-group">
                        <label for="request_edit" class="col-form-label">Request: </label>
                        (max: <span v-text="(max - request_edit.length)" style="color: blue;"></span>)
                        <textarea v-model="request_void" class="form-control" rows="5" :maxlength="max"></textarea>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="requestVoid">Process</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'PurchasingRequestEditModal',
  props: ['company'],
  data () {
    return {
      max: 100,
      request_edit: '',
      request_void: ''
    }
  },
  methods: {
    requestEdit () {
      this.$emit('getRequestEdit', this.request_edit)
    },
    requestVoid () {
      this.$emit('getRequestVoid', this.request_void)
    }
  }
}
</script>
